import ReactSlickModule from 'react-slick';

type SlickSliderComponent = typeof ReactSlickModule;
type ReactSlickCommonJsModule = { default: SlickSliderComponent };

// Vite 8 returns module.exports for default imports from CommonJS modules in ESM projects.
// react-slick exposes its component as module.exports.default, so unwrap that extra layer.
const reactSlickModule = ReactSlickModule as unknown as SlickSliderComponent | ReactSlickCommonJsModule;
const SlickSlider = 'default' in reactSlickModule ? reactSlickModule.default : reactSlickModule;

export default SlickSlider;
